import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { InteractionEndedDirective } from './interaction-ended.directive';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  NgbDatepickerModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbCollapse,
  NgbCollapseModule
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { FrequencyPipe } from './pipes/frequency.pipe';
import { DatePickerComponent } from './components/date-picker/date-picker.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import { OrdinalPipe } from './pipes/ordinal.pipe';
import { PaymentMethodTypePipe } from './pipes/payment-method-type.pipe';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ExpandingListComponent } from './components/expanding-list/expanding-list.component';
import { ExpandingListItemComponent } from './components/expanding-list-item/expanding-list-item.component';
import { BoostTableComponent } from './components/table/boost-table/boost-table.component';
import { SortableHeaderComponent } from './components/table/sortable-header/sortable-header.component';
import { PaginatePipe } from './components/table/paginate.pipe';
import { BoostInputSpinnerComponent } from './components/input-spinner/input-spinner.component';
import { PaymentInfoComponent } from './components/payment-info/payment-info.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CategoryNamesPipe } from './pipes/category-names.pipe';
import { ProductStatusPipe } from './pipes/product-status.pipe';
import { AsProductType } from './pipes/as-product-type.pipe';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { AuthnetHostedFormComponent } from './components/authnet-hosted-form/authnet-hosted-form.component';
import { StorefrontCurrencyPipe } from './pipes/storefront-currency.pipe';
import { PageHeaderComponent } from './components/page-header/page-header.component';
import { PricePipe } from './pipes/price.pipe';
import { RadioComponent } from './components/radio/radio.component';
import { CurrencyInputComponent } from './components/currency-input/currency-input.component';
import { TransactionTypePipe } from './pipes/transaction-type.pipe';
import { PreviewPipe } from './pipes/preview.pipe';
import { EnabledForDirective } from './directives/enabled-for.directive';
import { EnabledForAnyDirective } from './directives/enabled-for-any.directive';

const ngbModules = [
  NgbDatepickerModule,
  NgbPaginationModule,
  NgbTooltipModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbCollapseModule
];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    ...ngbModules,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true
    })
  ],
  declarations: [
    InteractionEndedDirective,
    PaymentInfoComponent,
    FrequencyPipe,
    OrdinalPipe,
    DatePickerComponent,
    PaymentMethodTypePipe,
    SpinnerComponent,
    ExpandingListComponent,
    ExpandingListItemComponent,
    BoostTableComponent,
    SortableHeaderComponent,
    PaginatePipe,
    CategoryNamesPipe,
    ProductStatusPipe,
    AsProductType,
    BoostInputSpinnerComponent,
    NotFoundComponent,
    UnauthorizedComponent,
    AuthnetHostedFormComponent,
    StorefrontCurrencyPipe,
    PageHeaderComponent,
    PricePipe,
    RadioComponent,
    CurrencyInputComponent,
    TransactionTypePipe,
    PreviewPipe,
    EnabledForDirective,
    EnabledForAnyDirective
  ],
  exports: [
    InteractionEndedDirective,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    ...ngbModules,
    PaymentInfoComponent,
    FrequencyPipe,
    OrdinalPipe,
    BoostTableComponent,
    BoostInputSpinnerComponent,
    SortableHeaderComponent,
    PaginatePipe,
    CategoryNamesPipe,
    ProductStatusPipe,
    AsProductType,
    NgxPermissionsModule,
    DatePickerComponent,
    PaymentMethodTypePipe,
    SpinnerComponent,
    ExpandingListComponent,
    ExpandingListItemComponent,
    AuthnetHostedFormComponent,
    StorefrontCurrencyPipe,
    PageHeaderComponent,
    CurrencyInputComponent,
    PricePipe,
    RadioComponent,
    TransactionTypePipe,
    PreviewPipe,
    EnabledForDirective,
    EnabledForAnyDirective
  ],
  providers: [CurrencyPipe, StorefrontCurrencyPipe]
  /* Do Not add providers here! Must add providers to the static forRoot() method */
})
export class SharedModule {
  // Used because of lazy loading modules. So that lazy modules don't get their own instances of services. Use forRoot only in appModule.
  // Used because of lazy loading modules. So that lazy modules don't get their own instances of services. Use forRoot only in appModule.
static forRoot(): ModuleWithProviders<SharedModule> {
    return {
        ngModule: SharedModule,
        providers: [
        /* Add Shared Services here */
        ]
    };
}
}
